import { HttpClient } from "./http-client";
import { Contact } from "../types/models/contact";

export class ContactService {
  private readonly http: HttpClient;

  constructor(apiUrl: string) {
    this.http = new HttpClient(apiUrl);
  }

  async getAllContacts(): Promise<Contact[]> {
    return this.http.get<Contact[]>("/api/gestionnaire/contacts");
  }

  async getContactById(idContact: number): Promise<Contact> {
    return this.http.get<Contact>(`/api/contacts/contacts/${idContact}`);
  }

  async updateContact(
    contactId: number,
    contact: { nom: string; prenom: string; telephone: string },
  ): Promise<void> {
    await this.http.put(`/api/account/${contactId}`, contact);
  }
}
